<template>
  <div class="drawer-wrapper" v-loading.fullscreen.lock="loading">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="dialogVisible" size="60%"
               :before-close="handleClose" direction="rtl">
      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">
            <el-col :span="24" class="mb20">
              <el-form-item label="酒店名字" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.name" placeholder="请输入酒店名字" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="封面图" prop="cover" :label-width="formLabelWidth">
                <ImageUpload v-model="addFrom.cover" />
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="详情图" :label-width="formLabelWidth">
                <ImageUpload v-model="addFrom.detail_images" :multiple="true" :limit="20" tip="可上传多张详情图" />
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="营业时间" prop="business_hours" :label-width="formLabelWidth">
                <el-input v-model="addFrom.business_hours" placeholder="如: 09:00-22:00" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="位置" prop="location" :label-width="formLabelWidth">
                <el-input v-model="addFrom.location" placeholder="请输入位置" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="房间简介" prop="room_intro" :label-width="formLabelWidth">
                <el-input v-model="addFrom.room_intro" placeholder="请输入房间简介" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="空间信息" prop="space_info" :label-width="formLabelWidth">
                <el-input v-model="addFrom.space_info" placeholder="请输入空间信息" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="设施与服务" prop="facilities" :label-width="formLabelWidth">
                <el-input v-model="addFrom.facilities" placeholder="请输入设施与服务" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="排序" prop="listorder" :label-width="formLabelWidth">
                <el-input-number v-model="addFrom.listorder" :min="0" controls-position="right"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="状态" :label-width="formLabelWidth">
                <el-radio-group v-model="addFrom.status">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="预定须知" :label-width="formLabelWidth">
                <RichEditor v-model="addFrom.booking_notice" placeholder="请输入预定须知" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { rcApis } from "@/api/rc";
import { processErrors } from "@/utils/errorHandler";
import ImageUpload from "@/components/ImageUpload";
import RichEditor from "@/components/RichEditor";
const api = rcApis();
export default {
  props: ['dialogVisible', "editID"],
  components: { ImageUpload, RichEditor },
  data() {
    return {
      title: "新增",
      formLabelWidth: "120px",
      addFrom: {
        name: "", cover: "", detail_images: [], business_hours: "", location: "",
        room_intro: "", space_info: "", facilities: "", booking_notice: "",
        listorder: 0, status: 1
      },
      loading: false,
      isask: false,
      rules: {
        name: [{ required: true, message: '请输入酒店名字', trigger: 'blur' }],
        cover: [{ required: true, message: '请上传封面图', trigger: 'change' }],
      },
    };
  },
  mounted() {
    if (this.editID != "") {
      this.loading = true;
      api.HotelInfo({ id: this.editID }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.title = "编辑";
          let data = res.data || {};
          // 详情图兼容: 字符串(JSON) / 数组 / 空
          if (typeof data.detail_images === 'string') {
            try {
              data.detail_images = data.detail_images ? JSON.parse(data.detail_images) : [];
            } catch (e) {
              data.detail_images = [];
            }
          }
          if (!Array.isArray(data.detail_images)) data.detail_images = [];
          this.addFrom = data;
        } else {
          processErrors(res);
        }
      });
    }
  },
  methods: {
    handleClose() {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },
    AddNone() {
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },
    addPush() {
      if (this.isask) return;
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.isask = true;
          let createText = this.editID == "" ? "创建成功" : "修改成功";
          let params = { ...this.addFrom };
          // 详情图以 JSON 字符串提交, 后端兼容解析
          params.detail_images = JSON.stringify(params.detail_images || []);
          if (this.editID != "") params.id = this.editID;
          api.HotelEdit(params).then(res => {
            this.isask = false;
            this.loading = false;
            if (res.code == 0) {
              this.$message.success(createText);
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          });
        } else {
          return false;
        }
      });
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content { height: calc(100% - 80px); overflow-y: auto; margin-top: 20px; overflow-x: hidden; }
.demo-drawer__footer { position: absolute; bottom: 0; left: 0; width: 100%; padding: 10px; text-align: center; }
.demo-drawer__footer .el-button { margin: 0 10px; width: calc(50% - 20px); }
</style>
